/**
 * Custom comment emojis (reactions + `:name:` in comment text).
 *
 * To add one:
 * 1. Put the file at `packages/ros-frontend/public/emojis/<file>`
 * 2. Add `{ name, filePath }` below (png, gif, webp, …)
 *
 * Shortcode is `:name:`. Keep names short (shortcode max ~32 chars).
 */
export const CUSTOM_EMOJIS = [
  { name: 'aaw_yeah', filePath: 'aaw_yeah.gif' },
  { name: 'krank-geil', filePath: 'krank-geil.png' },
  { name: 'mild_panic', filePath: 'mild_panic.png' },
  { name: 'sadge', filePath: 'sadge.png' },
  { name: 'stonks', filePath: 'stonks.png' },
  { name: 'surprised-pika', filePath: 'surprised-pika.png' },
  { name: 'this-is-fine-fire', filePath: 'this-is-fine-fire.gif' },
] as const satisfies ReadonlyArray<{ name: string; filePath: string }>;

export type CustomEmoji = {
  name: string;
  shortcode: string;
  src: string;
};

export const customEmojis: CustomEmoji[] = CUSTOM_EMOJIS.map(({ name, filePath }) => ({
  name,
  shortcode: `:${name}:`,
  src: `/emojis/${filePath}`,
}));

const byShortcode = new Map(customEmojis.map((emoji) => [emoji.shortcode, emoji]));

export const getCustomEmoji = (value: string): CustomEmoji | undefined => byShortcode.get(value);

export const isCustomEmojiShortcode = (value: string): boolean => byShortcode.has(value);
